/*!

=========================================================
* Paper Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Table,
	Row,
	Col,
} from "reactstrap";

class BuyersGuide extends React.Component {
	render() {
		return (
			<>
				<div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<CardTitle tag="h4">Buyers Guide</CardTitle>
								</CardHeader>
								<CardBody>
									<div style={{ overflowX: "auto" }}>
										<Table>
											<thead>
												<tr>
													<th>Name</th>
													<th>Country</th>
													<th>City</th>
													<th className="text-right">Salary</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>Dakota Rice</td>
													<td>Niger</td>
													<td>Oud-Turnhout</td>
													<td className="text-right">$36,738</td>
												</tr>
												<tr>
													<td>Minerva Hooper</td>
													<td>Curaçao</td>
													<td>Sinaai-Waas</td>
													<td className="text-right">$23,789</td>
												</tr>
												<tr>
													<td>Sage Rodriguez</td>
													<td>Netherlands</td>
													<td>Baileux</td>
													<td className="text-right">$56,142</td>
												</tr>
												<tr>
													<td>Philip Chaney</td>
													<td>Korea, South</td>
													<td>Overland Park</td>
													<td className="text-right">$38,735</td>
												</tr>
												<tr>
													<td>Doris Greene</td>
													<td>Malawi</td>
													<td>Feldkirchen in Kärnten</td>
													<td className="text-right">$63,542</td>
												</tr>
												<tr>
													<td>Mason Porter</td>
													<td>Chile</td>
													<td>Gloucester</td>
													<td className="text-right">$78,615</td>
												</tr>
												<tr>
													<td>Jon Porter</td>
													<td>Portugal</td>
													<td>Gloucester</td>
													<td className="text-right">$98,615</td>
												</tr>
											</tbody>
										</Table>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default BuyersGuide;
